import React, { useMemo } from 'react';
import { useIntl, getLocale } from 'umi';
import TextBubbles from '@home/components/TextBubbles';

import { releaseDateFormatter } from './utils';
import { IReleaseDateByPlatformProps, IReleaseInfo } from './types';

import './index.scss';

const ReleaseDateByPlatform: React.FC<IReleaseDateByPlatformProps> = (
  props,
) => {
  const { isRelease, list } = props;

  const emptyTipsLocaleKey = isRelease
    ? 'dbi_detail_release_date_by_platform_nodata_tips'
    : 'dbi_detail_game_not_launch_tips';

  const { formatMessage } = useIntl();
  const locale = getLocale();

  // 中英切换显示
  const formattedList = useMemo(() => {
    const listTmp = releaseDateFormatter?.(list, formatMessage) || list;
    return Array.isArray(listTmp) ? listTmp : [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale, list]);

  const renderContent = () => {
    if (!formattedList?.length)
      return <span>{formatMessage({ id: emptyTipsLocaleKey })}</span>;

    return (
      <div className="dbi-release-data-context">
        {formattedList?.map((item, index) => (
          <div className="dbi-release-data-row" key={index}>
            <TextBubbles
              className="dbi-release-data-label"
              text={item?.platform}
            />
            <div className="dbi-release-data-text">
              {item?.release_info?.map(
                (
                  { country, status, release_date }: IReleaseInfo,
                  subIndex: number,
                ) => {
                  const releaseDateStr = release_date
                    ? `${release_date} - `
                    : '';

                  return (
                    <TextBubbles
                      className="dbi-release-data-item"
                      key={subIndex}
                      text={`${country} - ${releaseDateStr}${status}`}
                    />
                  );
                },
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="dbi-release-data">
      <div className="dbi-release-data-title">
        {formatMessage({ id: 'dbi_release_date_by_platform' })}
      </div>
      {renderContent()}
    </div>
  );
};

export default ReleaseDateByPlatform;
